/*
# Keeping track of Map State
*/
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var toolChannel = Radio.channel('tool');
var Collection = require('../tool/collection');

module.exports = Backbone.Model.extend({
	defaults: {
		type: '',
		id: '',
		path: '',
		datum: {},
		selection: {},
		collection_copy: {},
		datum_hover: {},
		hover: {},
		matchedModels: {},
		matchedModelsColl: {},
		matched_models_active: {},
		matched_models_active_coll: {},
		zoomed: false,
		navi: 0,
		overview_data: {},
		first_run: true
	},

	initialize: function(){
		this.registerEvents();
	},

	registerEvents: function(){
		this.on('change:type', this.setBoundaryPath);
		this.on('change:datum', this.setSelection);
		this.on('change:datum_hover', this.setHover);
		toolChannel.on('startups:loaded', this.calculateOverview, this);
	},

	setBoundaryPath: function(model, type){
		// object literal lookups instead of switch or if/else for maximum fun, https://toddmotto.com/deprecating-the-switch-statement-for-object-literals/
		var paths = {
			'state_assembly': 'data/ca_state_assembly.json',
			'state_senate':		'data/ca_state_senate.json',
			'congressional':	'data/us_congressional.json',
			'county':					'data/counties-2012-10p.json',
			'default':				'data/counties-2012-10p.json'
		};

		this.set('path', (paths[type] || paths['default']) );
	},

	setSelection: function(model, d){
		var testID = this.get('id');
		if( testID === 0 || testID === '' ){
			this.set('selection',{});
			return;
		}

		var coll = this.get('collection_copy');

		var object_search_type = this.attributes.type + '_district_id';

		var county_link;

		if(d.properties.metadata.Name){
			county_link = d.properties.metadata.Name.toLowerCase().replace(/ /gi, "-");
			object_search_type = 'county_link';
		}else{
			object_search_type = this.attributes.type + '_district_id';
		}

		var matched_models = coll.get_matching_data(coll, this.attributes.id, object_search_type);
		this.set('matchedModels', matched_models);
		var matchedAsColl = coll.getMatchedAsColl(coll, this.attributes.id, object_search_type);
		this.set('matchedModelsColl', matchedAsColl);

		var matched_models_active = matchedAsColl.filter( {is_active: true } );
		this.set('matched_models_active', matched_models_active);
		this.set('matched_models_active_coll', new Collection(matched_models_active) );

		this.set('selection',{
			navi: this.get('navi'),
			boundary_kind: d.properties.kind.replace(/\(.*?\)/g , '').trim(),
			district_number: parseInt(d.properties.metadata.DISTRICT,10),
			district_name: d.properties.metadata.Name,
			county_link: county_link,
			total_revenue: coll.formatBigCurrency( coll.count_totals(matched_models_active, "total_revenue") ),
			num_employees: coll.formatCommas( coll.count_totals(matched_models_active, "employees") ),
			num_startups: matched_models_active.length,
			sbir: coll.formatBigCurrency( coll.count_totals(matched_models_active, "sbir_c") ),
			venture: coll.formatBigCurrency( coll.count_totals(matched_models_active, "venture_c") ),
			//population: coll.formatCommas( d.properties.metadata.POP )
		});
	},

	setHover: function(model, d){
		var coll = this.get('collection_copy').onlyActive();
		var hover;
		var object_search_type;

		if(this.attributes.type === 'county'){
			hover = {
				id: d.properties.metadata.Name.toLowerCase().replace(/ /gi, "-"),
				type: this.attributes.type
			};
			object_search_type = 'county_link';
		}else{
			hover = {
				id: parseInt(d.properties.metadata.DISTRICT,10),
				type: this.attributes.type
			};
			object_search_type = hover.type + '_district_id';
		}

		var matched_models = coll.get_matching_data(coll, hover.id, object_search_type);
		var county_link;

		if(d.properties.metadata.Name){
			county_link = d.properties.metadata.Name.toLowerCase().replace(/ /gi, "-");
		}

		this.set('hover',{
			boundary_kind: d.properties.kind.replace(/\(.*?\)/g , '').trim(),
			district_number: parseInt(d.properties.metadata.DISTRICT,10),
			district_name: d.properties.metadata.Name,
			county_link: county_link,
			total_revenue: coll.formatBigCurrency( coll.count_totals(matched_models, "total_revenue") ),
			num_employees: coll.formatCommas( coll.count_totals(matched_models, "employees") ),
			num_startups: matched_models.length,
			//population: coll.formatCommas( d.properties.metadata.POP )
		});
	},

	calculateOverview: function(){
		var coll = this.get('collection_copy').onlyActive();

		this.set('overview_data',{
			startups: _.size(coll),
			total_revenue: coll.formatBigCurrency( coll.reduce(function(memo, value) { return memo + value.get("total_revenue"); }, 0) ),
			employees: coll.formatCommas( coll.reduce(function(memo, value) { return memo + value.get("employees"); }, 0) ),
			sbir: coll.formatBigCurrency( coll.reduce(function(memo, value) { return memo + value.get("sbir_c"); }, 0) ),
			venture: coll.formatBigCurrency( coll.reduce(function(memo, value) { return memo + value.get("venture_c"); }, 0) ),
			//population: coll.formatCommas( d.properties.metadata.POP )
		});
	}

});
